import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip
} from "@material-ui/core";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { RemoveField } from "helpers/ReduxHelpers";
import _ from "lodash";
import React, { Fragment } from "react";
import { change, Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import DescriptiveRow from "../components/DescriptiveRow.jsx";
import { assetItems } from "./objects/assetItems";
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import GridItem from "components/Grid/GridItem.jsx";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value,
    margin: "0px"
  };
};

const CustomField = props => (
  <TableCell className="cellPaddingSmall">
    <FormControl fullWidth>
      <Field {...props} />
    </FormControl>
  </TableCell>
);

const CustomField2 = props => (
  
    <FormControl fullWidth style={{ bottom: "10px" }}>
      <Field {...props} />
    </FormControl>
  
);

const required = value => {
  console.log("req check", value);
  return value ? undefined : "Required";
};

function isInteger(value) {
  return /^\d+$/.test(value);
}

const percentage = value => {
  if (value === undefined) return undefined;

  if (isNaN(value)) {
    return "Must be a number";
  }

  if (parseInt(value, 10) >= 101 || parseInt(value, 10) < 0) {
    return "Not a valid Percentage";
  }
  return undefined;
};

const hundred = value => {
  if (value === undefined) return undefined;

  if (isNaN(value)) {
    return "Must be a number";
  }

  if (parseInt(value, 10) !== 100) {
    return "Must add up to 100";
  }

  return undefined;
};

var retirement = value => {
  return (
    {
      type: "",
      description: "",
      value: "",
      contributions: "",
      growth: "",
      return: ""
    }
  )
}

class Retirenment extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }

  addNew = () => {
    var retirements = this.props.state.retirement;
    retirements.push(retirement());
    this.props.changeRetirement(retirements);
  }

  remove = (n) => {
    var assets = this.props.state.retirement;
    var newAss = [];
    var node = n.target;
    
    while(node.nodeName != "BUTTON" && node.parentNode != null)
    {
      node = node.parentNode
    }
    
    var i = node.name.replace("remove", "")
    console.log(i)
    //assets.splice(i, 1)
    //assets[i] = null;
    assets.map((e,k) =>
    {
      
     
      if(e != assets[i])
      {
        newAss[k] = e
       
      }
        
    })

    console.log(newAss)
    assets = newAss;
    this.props.changeRetirement(assets);
  }
  
  
  
  
  
  
  changeType = (value, name) => {
    var retirements = this.props.state.retirement;
    var retirement = name.replace("type", "")
    retirements[retirement].type = value
    this.props.changeRetirement(retirements);
  }
  
  changeDescription= (value, name) => {
    var retirements = this.props.state.retirement;
    var retirement = name.replace("retirement.description", "")
    retirements[retirement].description = value
    this.props.changeRetirement(retirements);
  }
  changeValue= (value, name) => {
    var retirements = this.props.state.retirement;
    var retirement = name.replace("retirement.value", "")
    retirements[retirement].value = value
    this.props.changeRetirement(retirements);
  }
  changeContributions= (value, name) => {
    var retirements = this.props.state.retirement;
    var retirement = name.replace("retirement.contributions", "")
    retirements[retirement].contributions = value
    this.props.changeRetirement(retirements);
  }
  changeGrowth= (value, name) => {
    var retirements = this.props.state.retirement;
    var retirement = name.replace("retirement.growth", "")
    retirements[retirement].growth = value
    this.props.changeRetirement(retirements);
  }
  changeReturn= (value, name) => {
    var retirements = this.props.state.retirement;
    var retirement = name.replace("retirement.return", "")
    retirements[retirement].return = value
    this.props.changeRetirement(retirements);
  }

  

  checkItem = (label, name, changeFunc) => {
    return (
      
              <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px"}}>
                <Field
                  component={FormCheckbox}
                  name={name}
                  onChange={(e, f, g, h) => {
                    changeFunc(f, h)

                  }}

                />
              </FormControl>
           
    );
  };



  


  render() {
    let { checkValidation } = this.props;

    var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname

    return (
      <div className="contentWithStepper" style={{ width: "120%", marginLeft: "-10%" }}>
        <Card >
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"Retirement Fund Provisions"}
            />
<h4 style={{fontWeight: 500}}>Retirement Funds</h4>
            <Grid container spacing={24} className="customTableAutoGrid">
              
              <Table className="customTable1">
                <TableHead className="fixedHead">
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("20em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Type</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("15em")}
                      
                    >
                      <Typography style={{ fontSize: '16px' }}>
                        Description
                      </Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("16em")}
                      

                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                        Value
                      </Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("16em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Contributions</Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("16em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Annual Premium Growth</Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("16em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Annual Return</Typography>

                    </TableCell>
                  </TableRow>
                 </TableHead>
                <TableBody>

                  {this.props.state.retirement.map((e, i) => {

                    return (
                      <TableRow key={i}>
                        

                        <TableCell>
                          <Button
                            name={"remove" + i}
                            key = {"remove" + i}
                            variant="fab"
                            mini
                            className="tinyfab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>
                          <CustomField2
                            name={"type" + i}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={''}
                            isrequired={true}
                            
                            //validate={[required]}
                            options={[
                              {
                                displayValue: "Please Select",
                                value: " "
                              },
                              {
                                displayValue: "Pension Fund",
                                value: "pension"
                              },
                              {
                                displayValue: "RA",
                                value: "RA"
                              },
                              {
                                displayValue: "Provident Fund",
                                value: "provedentFund"
                              },
                              ,
                              {
                                displayValue: "Pension Preserver",
                                value: "pensionPreserver"
                              },
                              ,
                              {
                                displayValue: "Provident Preserver",
                                value: "provedentPreserver"
                              },
                            ]}
                            onChange={(e, value, t, name) => this.changeType(value, name)}
                            
                            
                          />
                        </TableCell>

                        <CustomField
                          name={'retirement.description' + i}
                          component={FormInput}
                          checkValidation={this.props.checkValidation}
                          label={'description'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeDescription(value, name)}
                        />

                        <CustomField
                          name={'retirement.value' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeValue(value, name)}
                        />

                        {
                          String(this.props.state.retirement[i].type).includes("Preserver") &&
                          <Typography></Typography>
                        }
                        {
                          !String(this.props.state.retirement[i].type).includes("Preserver") &&
                          <CustomField
                          name={'retirement.contributions' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeContributions(value, name)}
                         
                        />}

                        <CustomField
                          name={'retirement.growth' + i}
                          suffix="%"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'%*'}
                          isrequired={true}
                          validate={[required, percentage]}
                          onChange={(e, value, t, name) => this.changeGrowth(value, name)}
                        />

                        <CustomField
                          name={'retirement.return' + i}
                          suffix="%"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'%*'}
                          isrequired={true}
                          validate={[required, percentage]}
                          onChange={(e, value, t, name) => this.changeReturn(value, name)}
                        />

                       
                      </TableRow>

                    )

                  })}

                  <TableRow>
                    <Table style={{ width: "10em" }}>
                      <DescriptiveRow

                        description={"Add Asset"}
                        add={() =>
                          this.addNew()
                        }

                        extraCells={10}
                      />
                    </Table>
                  </TableRow>

                </TableBody>
              </Table>

            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default Retirenment;







// WEBPACK FOOTER //
// ./src/views/Fna/steps/Retirement.jsx